import React from "react";
import { useBrowserPageTitle } from "../../../components/BrowserPageTitle/BrowserPageTitle";
import { FilterableTablePayables } from "../components/TablePayables/FilterableTablePayables";

export const RoutePayablesAll: React.FC = () => {
  useBrowserPageTitle("All Payables");

  return (
    <FilterableTablePayables
      tab="all"
      showDownloadCsv
      visibleColumns={{
        payee: true,
        payableNumber: true,
        amount: true,
        dueDate: true,
        openedAt: true,
        paidAt: true,
        status: true
      }}
      visibleFilters={{
        payeeId: true,
        openedDateRange: true,
        paidDateRange: true
      }}
      emptyState={{
        firstTime:
          "Every requested, scheduled, and paid payable will display here.",
        standart: "No payables."
      }}
    />
  );
};
